import { Black } from "src/styles/color";

const IconDelivery = ({ width = "20", height = "16", fill = Black, style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M43.5 30H42.5V23.2437C42.5 22.45 42.1813 21.6875 41.6188 21.125L35.375 14.8812C34.8125 14.3187 34.05 14 33.2563 14H30.5V11C30.5 9.34375 29.1562 8 27.5 8H11.5C9.84375 8 8.5 9.34375 8.5 11V14H5C4.725 14 4.5 14.225 4.5 14.5V15.5C4.5 15.775 4.725 16 5 16H22C22.275 16 22.5 16.225 22.5 16.5V17.5C22.5 17.775 22.275 18 22 18H7C6.725 18 6.5 18.225 6.5 18.5V19.5C6.5 19.775 6.725 20 7 20H20C20.275 20 20.5 20.225 20.5 20.5V21.5C20.5 21.775 20.275 22 20 22H5C4.725 22 4.5 22.225 4.5 22.5V23.5C4.5 23.775 4.725 24 5 24H18C18.275 24 18.5 24.225 18.5 24.5V25.5C18.5 25.775 18.275 26 18 26H8.5V34C8.5 37.3125 11.1875 40 14.5 40C17.8125 40 20.5 37.3125 20.5 34H28.5C28.5 37.3125 31.1875 40 34.5 40C37.8125 40 40.5 37.3125 40.5 34H43.5C44.05 34 44.5 33.55 44.5 33V31C44.5 30.45 44.05 30 43.5 30ZM14.5 37C12.8438 37 11.5 35.6562 11.5 34C11.5 32.3438 12.8438 31 14.5 31C16.1562 31 17.5 32.3438 17.5 34C17.5 35.6562 16.1562 37 14.5 37ZM34.5 37C32.8438 37 31.5 35.6562 31.5 34C31.5 32.3438 32.8438 31 34.5 31C36.1562 31 37.5 32.3438 37.5 34C37.5 35.6562 36.1562 37 34.5 37ZM39.5 24H30.5V17H33.2563L39.5 23.2437V24Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconDelivery;
